import { render, staticRenderFns } from "./SeatsPreview.vue?vue&type=template&id=af6abae4&scoped=true&lang=pug&"
import script from "./SeatsPreview.vue?vue&type=script&lang=js&"
export * from "./SeatsPreview.vue?vue&type=script&lang=js&"
import style0 from "./SeatsPreview.vue?vue&type=style&index=0&id=af6abae4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6abae4",
  null
  
)

export default component.exports